import { Navbar } from "@/components/Navbar";
import { KineticHero } from "@/components/KineticHero";
import { EditorialMarquee } from "@/components/EditorialMarquee";
import { ManifestoChapters } from "@/components/ManifestoChapters";
import { ComplianceSection } from "@/components/ComplianceSection";
import { FaqSection } from "@/components/FaqSection";
import { Footer } from "@/components/Footer";

export default function LandingPage() {
  return (
    <div data-testid="landing-page" className="bg-[#FAF8F5]">
      <Navbar />
      <KineticHero />
      <EditorialMarquee />
      <ManifestoChapters />
      <ComplianceSection />
      <FaqSection />
      <Footer />
    </div>
  );
}
